import fileSaver from "file-saver";
import t from "./CustomModule.type";
import { activeInactive, activeInactiveCustomModuleGroup as activeInactiveCustomModuleGroupService, addLibraryToCustomModuleGroup, createControlType, createModule, deleteCMImageFromS3, deleteControlType, deleteCustomModuleGroup as deleteCustomModuleGroupService, deleteCustomModuleLibrary as deleteCustomModuleLibraryService, deleteCustomModuleLibraryPage, deleteModule, deleteMultipleModules, duplicateControl, duplicateCustomModuleLibrary as duplicateCustomModuleLibraryService, duplicateModule, editCustomModuleById, editCustomModuleGroupById, exportExcelService, getControlTypeById, getCustomModule, getCustomModuleContentData, getCustomModuleContentPage, getCustomModuleGroup, getCustomModuleGroupId, getCustomModuleId, getCustomModuleList, getDependentControlsList, getModuleById, getModuleDetailsWithSourceValues, getNewPageId, getPageCalculationControls, getPageControls, getSrcPages, insertCustomModule, insertCustomModuleGroup, listAllControls, listControlTypes, listModules, previewTemplateService, updateControlType, updateLibraryPageSequence, updateModule, uploadCMImageS3, saveModuleIcon } from "../../../../services/custom-module.services";
import { getPreWriteSignedWriteUrl, getPreReadSignedWriteUrl } from "../../../../services/s3Services";
import { toasterMsg } from "../../../../Components/Toaster/Toaster";
import i18next from "i18next";
import { getSlugName } from "../../../../Components/helper";

const translateMessage = (message, translationFunc) => {
  if (!message || typeof message !== "string") return message;

  if (message.startsWith("SYSTEM_CANVAS.")) {
    const translated = i18next.t(message, { ns: "custom-module-system-canvas" });
    if (translated && translated !== message) {
      return translated;
    }
  }

  if (typeof translationFunc === "function") {
    const translated = translationFunc(message, { ns: "custom-module-system-canvas" });
    if (translated && translated !== message) {
      return translated;
    }
    const translatedWithoutNs = translationFunc(message);
    if (translatedWithoutNs && translatedWithoutNs !== message) {
      return translatedWithoutNs;
    }
  }

  return message;
};

export const addCustomModule = (params, transactionMsg) => async () => {
  try {
    const dataString = JSON.stringify(params);
    let chunkSuccessful = null;
    chunkSuccessful = await insertCustomModule({ data: dataString });
    if (chunkSuccessful && chunkSuccessful.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${chunkSuccessful.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = chunkSuccessful.data?.errMsg;
      toasterMsg(transactionMsg(msg?.toString()), 'danger');
    }
    return chunkSuccessful;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateCustomModule = (params, id, transactionMsg) => async () => {
  try {
    const dataString = JSON.stringify(params);
    let chunkSuccessful = null;
    chunkSuccessful = await editCustomModuleById({ data: dataString }, id);
    if (chunkSuccessful?.code === 200) {
      const msg = transactionMsg(chunkSuccessful.message);
      toasterMsg(msg, 'success');
    } else {
      const msg = chunkSuccessful.data?.errMsg;
      toasterMsg(transactionMsg(msg.toString()), 'danger');
    }
    return chunkSuccessful;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllCustomModule = (params) => async (dispatch) => {
  try {
    const res = await getCustomModule({ params });
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCustomModuleById = (libId, pageId) => async (dispatch) => {
  try {
    const res = await getCustomModuleId(libId, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCustomModuleLibrary = (libIds, transactionMsg) => async () => {
  try {
    const res = await deleteCustomModuleLibraryService(libIds);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.data?.errMsg}`);
      toasterMsg(msg.toString(), 'danger');
    }

    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const UNMOUNT_LIBRARY_LIST = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_LIBRARY_LIST,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addCustomModuleGroup = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await insertCustomModuleGroup(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(transactionMsg(msg.toString()), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllCustomModuleGroup = (params) => async (dispatch) => {
  try {
    const res = await getCustomModuleGroup({ params });
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_GROUP,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const UNMOUNT_GROUP_LIST = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_GROUP_LIST,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCustomModuleGroupById = (libId) => async (dispatch) => {
  try {
    const res = await getCustomModuleGroupId(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateCustomModuleGroup = (params, id, transactionMsg) => async (dispatch) => {
  try {
    const res = await editCustomModuleGroupById(params, id);
    if (res?.code === 200) {
      const msg = transactionMsg(res.message);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = transactionMsg(res.data?.errMsg);
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCustomModuleGroup = (libIds, transactionMsg) => async () => {
  try {
    const res = await deleteCustomModuleGroupService(libIds);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = transactionMsg(res.data?.errMsg);
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addLibraryToGroup = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await addLibraryToCustomModuleGroup(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(transactionMsg(msg.toString()), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const duplicateCustomModuleLibrary = (data, transactionMsg) => async () => {
  try {
    const res = await duplicateCustomModuleLibraryService(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = transactionMsg(res.data?.errMsg);
    toasterMsg(msg.toString(), 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getOptionCustomModuleById = (libId) => async (dispatch) => {
  try {
    const res = await getCustomModuleId(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_FOR_OPTION,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const unmountLibrary = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_LIBRARY,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const downloadSampleFile = () => async () => {
  try {
    const res = await exportExcelService();
    if (res) {
      fileSaver.saveAs(res, 'Custom Module Table Sample');
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res?.message, 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(error.toString(), 'danger');
  }
};

export const activeInactiveCustomModuleLibrary = (data, transactionMsg) => async () => {
  try {
    const res = await activeInactive(data);

    if (res.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.code === 400) {
      const msg = transactionMsg(res?.data?.errMsg);
      toasterMsg(msg, 'danger');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveLibraryPages = (pagesData) => async (dispatch) => {
  try {
    await dispatch({
      type: t.LIBRARY_PAGES,
      payload: pagesData,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const uploadCMImage = (data) => async () => {
  try {
    const res = await uploadCMImageS3(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCMImage = (data, transactionMsg) => async () => {
  try {
    const res = await deleteCMImageFromS3(data);
    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getNewMongoId = () => async () => {
  try {
    const res = await getNewPageId();
    if (res.code === 200) {
      return res.data;
    }
    return null;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCustomLibraryPage = (params, transactionMsg) => async () => {
  try {
    const res = await deleteCustomModuleLibraryPage(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.data?.errMsg}`);
      toasterMsg(msg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCMPageList = (libId) => async (dispatch) => {
  try {
    const res = await getCustomModuleList(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updatePageSequence = (data, libId, transactionMsg) => async () => {
  try {
    const res = await updateLibraryPageSequence(data, libId);
    if (res?.code === 200) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getContentPageData = (libId) => async () => {
  try {
    const res = await getCustomModuleContentPage(libId);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCMPageControlList = (customModuleLibId, pageId) => async (dispatch) => {
  try {
    const res = await getPageControls(customModuleLibId, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const getCMPagesList = (customModuleLibId) => async (dispatch) => {
  try {
    const res = await getSrcPages(customModuleLibId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_PAGE_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getDependentPagesList = (customModuleLibId) => async (dispatch) => {
  try {
    const res = await getDependentControlsList(customModuleLibId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_DEPENDENT_CONTROL_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getLibraryCMContentPage = (libId) => async (dispatch) => {
  try {
    const res = await getCustomModuleContentData(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllCustomModuleForCalculations = (params) => async (dispatch) => {
  try {
    const res = await getCustomModule({ params });
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_CUSTOM_MODULE_FOR_CALCULATION,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearCalculationList = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_ALL_CUSTOM_MODULE_FOR_CALCULATION,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCalculationPagesList = (customModuleLibId) => async (dispatch) => {
  try {
    const res = await getSrcPages(customModuleLibId, { withoutCP: true });
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_CALCULATION_PAGE_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearCalculationPageList = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_CUSTOM_MODULE_CALCULATION_PAGE_LIST,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCalculationPageControlList = (customModuleLibId, pageId) => async (dispatch) => {
  try {
    const res = await getPageCalculationControls(customModuleLibId, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST_FOR_CALCULATION,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearCalculationControlList = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST_FOR_CALCULATION,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const previewSampleFile = (data) => async () => {
  try {
    const res = await previewTemplateService(data);
    if (res.data && res.code === 200) {
      return res;
    }
    toasterMsg(res.message, 'danger');
  } catch (error) {
    toasterMsg(error, 'danger');
  }
};

export const activeInactiveCustomModuleGroup = (objData, translationFunc) => async () => {
  try {
    const res = await activeInactiveCustomModuleGroupService(objData);
    if (res?.code === 200) {
      toasterMsg(translationFunc('CUSTOM_MODULES.GROUP.CUSTOM_LIST.STATUS_UPDATED_SUCCESS'), 'success');
      return res;
    }
    toasterMsg(res.data?.errMsg, 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return false;
  }
};

export const getSystemCanvasControlTypes =
  (params = {}) =>
  async (dispatch) => {
    try {
      const res = await listControlTypes(params);
      if (res?.code === 200) {
        await dispatch({
          type: t.GET_SYSTEM_CANVAS_CONTROL_TYPES,
          payload: res?.data?.controls || [],
        });
        return res;
      }
      const msg = res.data?.errMsg;
      toasterMsg(msg?.toString(), "danger");
    } catch (err) {
      toasterMsg(translateMessage(systemCanvasErrorKey(err, err.toString())), "danger");
    }
  };

export const getSystemCanvasControlTypeById = (id) => async (dispatch) => {
  try {
    const res = await getControlTypeById(id);
    if (res?.code === 200 && res?.data) {
      await dispatch({
        type: t.GET_SYSTEM_CANVAS_CONTROL_TYPE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res?.data?.errMsg || "Control data not found";
    toasterMsg(msg?.toString(), "danger");
    throw new Error(msg);
  } catch (err) {
    const errorMsg = systemCanvasErrorKey(err, err?.message || err?.toString() || "Failed to load control data");
    toasterMsg(errorMsg, "danger");
    throw err;
  }
};

export const createSystemCanvasControlType = (data, translationFunc) => async () => {
  try {
    const res = await createControlType(data);
    if (res?.code === 200) {
      const message = res.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_CONTROL_CREATED";
      toasterMsg(translateMessage(message, translationFunc), "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    if (msg) {
      toasterMsg(translateMessage(msg, translationFunc), "danger");
    } else {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_CREATE_CONTROL_TYPE", translationFunc), "danger");
    }
    return res;
  } catch (err) {
    toasterMsg(translateMessage(systemCanvasErrorKey(err, "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_CREATE_CONTROL_TYPE"), translationFunc), "danger");
    throw err;
  }
};

export const updateSystemCanvasControlType = (id, data, translationFunc) => async () => {
  try {
    const res = await updateControlType(id, data);
    if (res?.code === 200) {
      const message = res.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_CONTROL_UPDATED";
      toasterMsg(translateMessage(message, translationFunc), "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    if (msg) {
      toasterMsg(translateMessage(msg, translationFunc), "danger");
    } else {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_UPDATE_CONTROL_TYPE", translationFunc), "danger");
    }
  } catch (err) {
    toasterMsg(translateMessage(systemCanvasErrorKey(err, "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_UPDATE_CONTROL_TYPE"), translationFunc), "danger");
  }
};

export const deleteSystemCanvasControlType = (id, translationFunc) => async () => {
  try {
    const res = await deleteControlType(id);
    if (res?.code === 200) {
      const message = res.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_CONTROL_DELETED";
      toasterMsg(translateMessage(message, translationFunc), "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    if (msg) {
      toasterMsg(translateMessage(msg, translationFunc), "danger");
    } else {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DELETE_CONTROL_TYPE", translationFunc), "danger");
    }
  } catch (err) {
    toasterMsg(translateMessage(systemCanvasErrorKey(err, "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DELETE_CONTROL_TYPE"), translationFunc), "danger");
  }
};

export const getSystemCanvasModules =
  (params = {}) =>
  async (dispatch) => {
    try {
      const res = await listModules(params);
      if (res?.code === 200) {
        const modules = res?.data?.modules || [];
        await dispatch({
          type: t.GET_SYSTEM_CANVAS_MODULES,
          payload: params.isScrolled ? { append: true, modules } : modules,
        });
        return res;
      }
      const msg = res.data?.errMsg;
      toasterMsg(msg?.toString(), "danger");
    } catch (err) {
      toasterMsg(translateMessage(systemCanvasErrorKey(err, err.toString())), "danger");
    }
  };

export const getAllSystemCanvasControls =
  (params = {}) =>
  async (dispatch) => {
    try {
      const res = await listAllControls(params);
      if (res?.code === 200) {
        const controls = res?.data?.controls || [];
        await dispatch({
          type: t.GET_SYSTEM_CANVAS_CONTROLS,
          payload: params.isScrolled ? { append: true, controls } : controls,
        });
        return res;
      }
      const msg = res.data?.errMsg;
      toasterMsg(msg?.toString(), "danger");
    } catch (err) {
      toasterMsg(translateMessage(systemCanvasErrorKey(err, err.toString())), "danger");
    }
  };

export const getSystemCanvasModuleById = (id, params) => async (dispatch) => {
  try {
    const res = await getModuleById(id, params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SYSTEM_CANVAS_MODULE_BY_ID,
        payload: res?.data?.module,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg?.toString(), "danger");
  } catch (err) {
    toasterMsg(translateMessage(systemCanvasErrorKey(err, err.toString())), "danger");
  }
};

export const getSystemCanvasModuleDetailsWithSourceValues =
  (id, devOrderId = null, timezone = "UTC") =>
  async (dispatch) => {
    try {
      const res = await getModuleDetailsWithSourceValues(id, devOrderId, timezone);
      if (res?.code === 200) {
        await dispatch({
          type: t.GET_SYSTEM_CANVAS_MODULE_BY_ID,
          payload: res?.data?.module,
        });
        return res;
      }
      const msg = res.data?.errMsg;
      toasterMsg(msg?.toString(), "danger");
    } catch (err) {
      toasterMsg(translateMessage(systemCanvasErrorKey(err, err.toString())), "danger");
    }
  };

export const createSystemCanvasModule = (data, translationFunc) => async () => {
  try {
    const res = await createModule(data);
    if (res?.code === 200) {
      const message = res.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_MODULE_CREATED";
      toasterMsg(translateMessage(message, translationFunc), "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    if (msg) {
      toasterMsg(translateMessage(msg, translationFunc), "danger");
    } else {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_CREATE_MODULE", translationFunc), "danger");
    }
  } catch (err) {
    toasterMsg(translateMessage(systemCanvasErrorKey(err, "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_CREATE_MODULE"), translationFunc), "danger");
  }
};

export const updateSystemCanvasModule = (id, data, translationFunc) => async () => {
  try {
    const res = await updateModule(id, data);
    if (res?.code === 200) {
      const message = res.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_MODULE_UPDATED";
      toasterMsg(translateMessage(message, translationFunc), "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    if (msg) {
      toasterMsg(translateMessage(msg, translationFunc), "danger");
    } else {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_UPDATE_MODULE", translationFunc), "danger");
    }
  } catch (err) {
    toasterMsg(translateMessage(systemCanvasErrorKey(err, "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_UPDATE_MODULE"), translationFunc), "danger");
  }
};

export const deleteSystemCanvasModule = (id, translationFunc) => async () => {
  try {
    const res = await deleteModule(id);
    if (res?.code === 200) {
      const message = res.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_MODULE_DELETED";
      toasterMsg(translateMessage(message, translationFunc), "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    if (msg) {
      toasterMsg(translateMessage(msg, translationFunc), "danger");
    } else {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DELETE_MODULE", translationFunc), "danger");
    }
  } catch (err) {
    const errorData = err?.response?.data;
    const errorMsg = errorData?.data?.errMsg || errorData?.errMsg || errorData?.message || err?.message;
    const errorKey = errorMsg || "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DELETE_MODULE";
    toasterMsg(translateMessage(errorKey, translationFunc), "danger");
  }
};

export const deleteMultipleSystemCanvasModules = (ids, translationFunc) => async () => {
  try {
    const res = await deleteMultipleModules(ids);
    if (res?.code === 200) {
      const message =
        res.message ||
        (ids.length === 1 ? "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_MODULE_DELETED" : "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_MODULES_DELETED");
      const translatedMessage = translateMessage(message, translationFunc);
      const finalMessage =
        ids.length === 1 ? translatedMessage : i18next.t(message, { ns: "custom-module-system-canvas", count: ids.length }) || translatedMessage;
      toasterMsg(finalMessage, "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    if (msg) {
      const moduleNames = res.data?.moduleNames;
      if (moduleNames && Array.isArray(moduleNames) && moduleNames.length > 0) {
        const moduleNamesList = moduleNames.join(", ");
        const errorMessage = `${translateMessage(msg, translationFunc)}: ${moduleNamesList}`;
        toasterMsg(errorMessage, "danger");
      } else {
        toasterMsg(translateMessage(msg, translationFunc), "danger");
      }
    } else {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DELETE_MODULE", translationFunc), "danger");
    }
  } catch (err) {
    const errorData = err?.response?.data;
    const errorMsg = errorData?.data?.errMsg || errorData?.errMsg || errorData?.message || err?.message;
    const moduleNames = errorData?.data?.moduleNames || errorData?.moduleNames;
    const errorKey = errorMsg || "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DELETE_MODULE";
    if (moduleNames && Array.isArray(moduleNames) && moduleNames.length > 0) {
      const moduleNamesList = moduleNames.join(", ");
      const errorMessage = `${translateMessage(errorKey, translationFunc)}: ${moduleNamesList}`;
      toasterMsg(errorMessage, "danger");
    } else {
      toasterMsg(translateMessage(errorKey, translationFunc), "danger");
    }
  }
};

export const duplicateSystemCanvasModule = (id, name, translationFunc) => async () => {
  try {
    const res = await duplicateModule(id, { name });
    if (res?.code === 200) {
      const message = res.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_MODULE_DUPLICATED";
      toasterMsg(translateMessage(message, translationFunc), "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    const errorMessage = msg || "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DUPLICATE_MODULE";
    toasterMsg(translateMessage(errorMessage, translationFunc), "danger");
    throw new Error(translateMessage(errorMessage, translationFunc));
  } catch (err) {
    const errorMessage = systemCanvasErrorKey(err, err.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DUPLICATE_MODULE");
    toasterMsg(translateMessage(errorMessage, translationFunc), "danger");
    throw err;
  }
};

export const duplicateSystemCanvasControl = (id, name, translationFunc) => async () => {
  try {
    const res = await duplicateControl(id, { name });
    if (res?.code === 200) {
      const message = res.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_CONTROL_DUPLICATED";
      toasterMsg(translateMessage(message, translationFunc), "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    const errorMessage = msg || "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DUPLICATE_CONTROL_TYPE";
    toasterMsg(translateMessage(errorMessage, translationFunc), "danger");
    throw new Error(translateMessage(errorMessage, translationFunc));
  } catch (err) {
    const errorMessage = systemCanvasErrorKey(err, err.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_DUPLICATE_CONTROL_TYPE");
    toasterMsg(translateMessage(errorMessage, translationFunc), "danger");
    throw err;
  }
};

export const saveSystemCanvasModule = (data, translationFunc) => async () => {
  try {
    const res = await createModule(data);
    if (res?.code === 200) {
      const message =
        res.message ||
        (data._id ? "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_MODULE_UPDATED" : "SYSTEM_CANVAS.BACKEND_CONTROLLER.CUSTOM_MODULE_MODULE_CREATED");
      toasterMsg(translateMessage(message, translationFunc), "success");
      return res;
    }
    const msg = res.data?.errMsg || res.message;
    if (msg) {
      toasterMsg(translateMessage(msg, translationFunc), "danger");
    } else {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_CREATE_MODULE", translationFunc), "danger");
    }
  } catch (err) {
    toasterMsg(translateMessage(systemCanvasErrorKey(err, "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_CREATE_MODULE"), translationFunc), "danger");
  }
};

export const uploadModuleIcon = (moduleId, file, translationFunc) => async (dispatch) => {
  try {
    if (!moduleId || typeof moduleId !== "string") {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.INVALID_ID", translationFunc), "danger");
      return;
    }

    const timestamp = Date.now();
    const objectKey = `${getSlugName()}/custom_module_assets/system-canvas-icons/${String(moduleId).trim()}_${timestamp}.svg`;

    if (!objectKey || typeof objectKey !== "string") {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_GET_PRESIGNED_URL", translationFunc), "danger");
      return;
    }

    const presignedUrlRes = await getPreWriteSignedWriteUrl({
      objectKey,
      expiresInSeconds: 3600,
    });

    if (presignedUrlRes?.code !== 200 || !presignedUrlRes?.data) {
      toasterMsg(translateMessage("SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_GET_PRESIGNED_URL", translationFunc), "danger");
      return;
    }

    const presignedUrl = presignedUrlRes.data;

    const fileContent = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });

    const uploadResponse = await fetch(presignedUrl, {
      method: "PUT",
      body: fileContent,
      headers: {
        "Content-Type": "image/svg+xml",
      },
    });
    if (!uploadResponse.ok) {
      throw new Error(`Upload failed with status: ${uploadResponse.status}`);
    }

    saveModuleIcon(moduleId, objectKey)
      .then((res) => {
        if (res?.code === 200 && res?.data?.iconUrl) {
          dispatch({
            type: t.UPDATE_SYSTEM_CANVAS_MODULE_ICON,
            payload: {
              moduleId: String(moduleId).trim(),
              iconUrl: res?.data?.iconUrl,
            },
          });
          const message = res.message || "SYSTEM_CANVAS.BACKEND_CONTROLLER.MODULE_ICON_UPLOADED";
          toasterMsg(translateMessage(message, translationFunc), "success");
        } else {
          const msg = res?.data?.errMsg || res?.message;
          const errorKey = msg || "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_UPLOAD_ICON";
          toasterMsg(translateMessage(errorKey, translationFunc), "danger");
        }
      })
      .catch((err) => {
        const errorKey = systemCanvasErrorKey(err, "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_UPLOAD_ICON");
        toasterMsg(translateMessage(errorKey, translationFunc), "danger");
      });
  } catch (err) {
    const errorKey = "SYSTEM_CANVAS.BACKEND_CONTROLLER.FAILED_TO_UPLOAD_ICON";
    toasterMsg(err?.toString() || translateMessage(errorKey, translationFunc), "danger");
    throw err;
  }
};

function systemCanvasErrorKey(err, fallbackKey) {
  const responseMessage = err?.response?.data?.message;
  return typeof responseMessage === "string" && responseMessage ? responseMessage : fallbackKey;
}
